export default function Input({ label, id, name, ...rest }) {
    return (
        <div className="flex flex-col">
            <label className="text-left text-general-80 text-sm" htmlFor={id}>{label}</label>
            <input type="text" className="border text-general-100 rounded border-[#D9E1EC] active:border-[#D9E1EC] placeholder-general-60 p-2" id={id} name={name} {...rest} />
        </div>
    );
}